import '../../scss/streetstyle-search.scss';

import {initRelatedTags} from '../common/similarTags';

const initFilters = require('./filters');
require('../common/viewer');
require('../common/stickySearch');
require('../common/photoSizeControl');
initFilters();
initRelatedTags();
